import Header from "../components/Header";
import ValidatorTable from "../components/ValidatorTable";

const Home = () => {
  return (
    <div>
      <Header />
      <ValidatorTable />
    </div>
  );
};

export default Home;
